const home = {
  "home.get.the.app.title": "Be Your Best Apps",
  "home.subscription.success.title": "Thanks for signing up",
  "home.subscription.success.description": "It's great to have you onboard. You have an exciting journey ahead of you.",
  "home.account.setup.blocker.description": "Please wait while we finish setting up your account and authorizing your access.",
  "home.get.vr.title": "Get the VR app",
  "home.get.vr.meta": "Meta Quest app",
  "home.get.mobile.title": "Get the mobile app",
  "home.get.mobile.android": "Android app",
  "home.get.mobile.ios": "iOS app",
  "home.profile.setup.continue": "Complete profile setup",
};

export const portalHome = {
  ...home,
};
